function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.896 11.665l-4.23-4.23 4.23-4.23c1.63-1.63-.899-4.16-2.53-2.529l-4.23 4.23-4.23-4.23c-1.63-1.63-4.16.899-2.529 2.53l4.23 4.23-4.23 4.229c-1.63 1.631.899 4.16 2.53 2.53l4.23-4.23 4.23 4.23c1.63 1.63 4.16-.9 2.529-2.53z",
  fill: "#E6E6E6"
});

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCross;